<template>
    <aside class="sidebar">
      <div class="sidebar-head">
        <div class="stat">
          <div class="k">頁數</div>
          <div class="v">{{ pages.length || 0 }}</div>
        </div>
        <div class="stat">
          <div class="k">已分析</div>
          <div class="v">{{ analyzedCount }}/{{ pages.length || 0 }}</div>
        </div>
  
        <div class="lang-row">
          <label>OCR 語言</label>
          <select :value="ocrLang" @change="onLangChange">
            <option value="eng">English (eng)</option>
            <option value="chi_tra">繁體中文 (chi_tra)</option>
            <option value="chi_sim">简体中文 (chi_sim)</option>
            <option value="jpn">日本語 (jpn)</option>
            <option value="kor">한국어 (kor)</option>
          </select>
        </div>
      </div>
  
      <SidebarDropzone
        :selectedFile="selectedFile"
        @pick="$emit('pick')"
        @filePicked="$emit('filePicked', $event)"
      />
  
      <PagesList
        v-if="pdfLoaded"
        :pages="pages"
        :currentPageNumber="currentPageNumber"
        @goPage="$emit('goPage', $event)"
        @analyze="$emit('analyze', $event)"
        @needThumb="$emit('needThumb', $event)"
      />
    </aside>
  </template>
  
  <script setup lang="ts">
  import type { PageState } from '@/types/ainotebook'
  import SidebarDropzone from './SidebarDropzone.vue'
  import PagesList from './PagesList.vue'
  
  const props = defineProps<{
    pdfLoaded: boolean
    pages: PageState[]
    selectedFile: File | null
    ocrLang: 'eng'|'chi_tra'|'chi_sim'|'jpn'|'kor'
    analyzedCount: number
    currentPageNumber: number
  }>()
  
  const emit = defineEmits<{
    (e: 'pick'): void
    (e: 'filePicked', f: File): void
    (e: 'goPage', n: number): void
    (e: 'analyze', n: number): void
    (e: 'needThumb', n: number): void
    (e: 'updateOcrLang', v: typeof props.ocrLang): void
  }>()
  
  function onLangChange(e: Event) {
    const v = (e.target as HTMLSelectElement).value as any
    emit('updateOcrLang', v)
  }
  </script>
  
  <style scoped lang="scss">
  .sidebar {
    min-height: 0;
    height: 100%;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 16px;
    background: rgba(10,18,33,0.55);
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  
    .sidebar-head {
      padding: 12px;
      display: grid;
      gap: 10px;
      border-bottom: 1px solid rgba(255,255,255,0.06);
  
      .stat {
        display: flex;
        justify-content: space-between;
        .k { color: rgba(232,238,252,0.6); font-size: 12px; }
        .v { font-weight: 700; }
      }
  
      .lang-row {
        display: grid;
        gap: 6px;
        label { font-size: 12px; color: rgba(232,238,252,0.65); }
        select {
          height: 38px;
          border-radius: 12px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.10);
          color: #e8eefc;
          padding: 0 10px;
          outline: none;
        }
      }
    }
  }
  
  @media (max-width: 720px) {
    .sidebar { display: none; }
  }
  </style>
  